<template>
  <tr>
    <td class="align-middle">{{ licenceData.licence_number }}</td>
    <td style="width: 50px;" class="align-middle">
      <d-button
        theme="danger"
        size="sm"
        :disabled="removeInProgress"
        @click.prevent="removeLicence"
        title="Delete">
        <i class="material-icons">delete</i>
      </d-button>
    </td>
  </tr>
</template>

<script>
import ListUtils from './../../utils/ListUtils.js';

export default {
  name: 'licences-list-item',
  props: {
    licenceData: {
      type: Object,
      default: () => ({}),
      required: true
    }
  },
  data () {
    return {
      removeInProgress: false
    };
  },
  methods: {
    removeLicence () {
      this.removeInProgress = true;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: '/crews/licences/delete/',
        id: parseInt(this.licenceData.id, 10),
        successTitle: 'Licence removed',
        successText: 'The selected licence has been removed',
        confirmTitle: 'Do you really want to remove this licence?',
        confirmText: 'This operation cannot be reverted',
        errorTitle: 'An error occurred',
        errorText: 'Please try again.',
        successAction: () => {
          this.removeInProgress = false;
          this.$bus.$emit('licences-list-reload');
        },
        cancelAction: () => {
          this.removeInProgress = false;
        },
        errorAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  }
};
</script>
